<template>
  <div class="psr-navbar">
    <v-toolbar class="grey darken-4" dark dense fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <!-- <v-toolbar-title v-text="title"></v-toolbar-title> -->
      <img style="width:150px;height:40px;margin-left:1vw;" src="https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png" alt="Bezzina" @click="$router.push('/')">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-for="(link, index) in links" :key="index" @click="$router.push(link.path)" slot="activator" flat :style="{color : $route.path.indexOf(link.name.toLowerCase()) !== -1 ? 'orange' : 'white'}">
          {{ link.name }}
        </v-btn>
      </v-toolbar-items>
      </v-toolbar>
      <v-navigation-drawer class="hidden-md-and-up" v-model="drawer" temporary fixed floating>
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title" @click="$router.push('/')">
            <v-icon>{{ "fa fa-home" }}</v-icon><span style="padding-left: 30px;">Home</span>
          </v-list-tile-title>
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer = !drawer" class="hidden-md-and-up">highlight_off</v-icon>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list dense class="pt-0">
      <v-list-tile v-for="(link, index) in links" :key="index">
        <v-list-tile-action @click="$router.push(link.path)">
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title @click="$router.push(link.path)">{{ link.name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  </div>
  </template>

  <script>
  export default {
    data () {
      return {
        title: 'Bezzina',
        links: [
          {
            name: 'Experience',
            items: [
              'Company Profile',
              'Events',
              'News',
              'Office',
              'Aviation',
              'Interviews',
              'Videos',
              'Contact us'
            ],
            path: '/experience',
            icon: 'fa fa-trophy'
          },
          {
            name: 'Works',
            items: [
              'Point Piper SIENNA',
              'Surfers Paradise JADE',
              'Burraneer Bay TARA',
              'Elouera Beach MIA',
              'Cronulla Beach TIANA',
              'Stanmore THE METERHOUSE',
              'Turramura Retirement Village THE LANDINGS',
              'Redferen THE FOUNDRY',
              'Balmain DOCKSIDE',
              'Redfern SIGNATURES',
              'Taloombi street residence'
            ],
            path: '/works',
            icon: 'fa fa-building'
          },
          {
            name: 'Design',
            items: [
              'Interior',
              'Landscape',
              'Materials',
              'Lifestyle'
            ],
            path: '/design',
            icon: 'fa fa-diamond'
          },
          {
            name: 'Contact',
            items: [
            ],
            path: '/contact',
            icon: 'fa fa-address-book'
          },
          {
            name: 'About',
            items: [
            ],
            path: '/about',
            icon: 'fa fa-question-circle'
          }
        ],
        drawer: null
        // navitems: [
        //   {text: 'Experience', navlink: '#experience'},
        //   {text: 'Works', navlink: '#works'},
        //   {text: 'Design', navlink: '#design'}
        // ]
        // dropdownitems: [
        //   {text: 'Corporate', dropdownitems: [{text: 'History', navlink: '#history'}, {text: 'Awards', navlink: '#awards'}, {text: 'Sponsorship', navlink: '#sponsorship'}]},
        //   {text: 'Style', dropdownitems: [{text: 'Design', navlink: '#design'}, {text: 'Interiors', navlink: '#interiors'}, {text: 'Landscaping', navlink: '#landscaping'}]}
        // ]
      }
    },
    methods: {
      showComponent (component) {
        this.$emit('changeComponent', component)
        setTimeout(function () {
          window.location.hash = '#' + component.toLowerCase().replace(/\s/g, '')
        }, 100)
      }
    }
  }
</script>

<style>
  .psr-navbar {
    /*font-family: 'Roboto', sans-serif;*/
    font-family: 'Lato', sans-serif;
    /*font-family: 'Source Sans Pro', sans-serif;*/
  }
</style>


// WEBPACK FOOTER //
// src/components/NavigationComponent.vue